import { UIHeading1 } from '@cian/ui-kit';
import * as React from 'react';

import { AdvantageItem } from './parts';
import * as style from './style.css';
import { IAdvantageItemProps } from './utils/types';

interface IAdvantagesProps {
  testId: string;
  heading: string;
  items: IAdvantageItemProps[];
}

export const Advantages: React.FC<IAdvantagesProps> = ({ testId, heading, items }) => {
  return (
    <div data-testid={testId} className={style['container']}>
      <div className={style['heading']}>
        <UIHeading1>{heading}</UIHeading1>
      </div>

      <div className={style['wrapper']}>
        {items.map((props, index) => (
          <AdvantageItem key={props.heading + index} {...props} />
        ))}
      </div>
    </div>
  );
};
